import './PatientCgs.scss';

import { useEffect } from 'react';

import { useReducer } from 'lib/hooks/useReducer';
import { useDispatch } from 'react-redux';

import { Layout } from 'antd';
import { FormUnsavedChangesWrapper } from 'components';

import cgsInventories, { initialState } from './cgsSlice';

import { OutcomeMeasuresHeader } from 'components/header';
import { setFaqObject } from 'navigation/utils/navigationSlice';

import { cleanPagedQuestionnaireStorage } from 'features/patient/assessment/_utils/questionnaire-local-storage';
import { PaginationCombined } from './cgs-pagination-combined';

export function PatientCgs() {
  const faqDispatch = useDispatch();
  const [{ cgs }] = useReducer(cgsInventories, initialState);

  useEffect(() => {
    faqDispatch(
      setFaqObject({
        min: (cgs as any).min,
        max: (cgs as any).max,
        instructions: (cgs as any).instructions,
        description: (cgs as any).description
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout style={{ backgroundColor: 'white' }}>
      <OutcomeMeasuresHeader
        label={'Exit'}
        title="2nd Questionnaire"
        onExit={() => {
          cleanPagedQuestionnaireStorage('questionnaire-cgs');
        }}
      />
      <FormUnsavedChangesWrapper>
        <PaginationCombined storageKey="questionnaire-cgs" />
      </FormUnsavedChangesWrapper>
    </Layout>
  );
}
